module.exports = __webpack_public_path__ + "img/selectPer.0ad63f43.png";